import yup from '@/init/yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const ResetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required('入力してください')
    .matches(
      /(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[#$%])/,
      'パスワードには半角英数の大文字、小文字、記号（#$%）各1つ以上を含め、8文字以上で入力してください。',
    ),
  confirm_password: yup
    .string()
    .required('入力してください')
    .oneOf([yup.ref('password'), ''], 'パスワードが一致しません'),
});
export type ResetPasswordType = yup.InferType<typeof ResetPasswordSchema>;
export const ResetPasswordResolver = yupResolver(ResetPasswordSchema);
